import { Dispatch, SetStateAction } from "react";
import { Event, Track, TrackVersion } from "./../../proto/api_pb.d";
import {
  FolderUploadInfo,
  UploadCardStatusInfo,
  UploadedFileInfo,
} from "../../components/FileUploadStatusCard/types";
import { Inbox, Session } from "talkjs/all";

export interface TrackProps {
  item: TrackObj;
  setAudioTrack: (id: string, audioTrack: WaveSurfer) => void;
  handlePlay: (id: string) => void;
  handleStop: (id: string) => void;
  handleOpen: (id: string) => void;
  displayForTrackDetails?: boolean;
  setLoading?: Dispatch<SetStateAction<boolean>>;
  versionId?: string;
  setSelectedVersion?: Dispatch<SetStateAction<TrackVersionsObj | undefined>>;
  handleState: (state: string) => void;
  state: string;
  handlePreviewState: (state: string) => void;
  previewState: string;
  openDeleteConfirmModal: (id: string) => void;
  expand?: boolean;
  userVerified?: boolean;
  handleOpenCollabsModal?: (id: string) => void;
  handleOpenVersionModal?: (id: string) => void;
  handleFetch?: () => Promise<void>;
  handleOpenTrackFileModal?: (id: string) => void;
  playingTime?: any;
  setPlayingTime?: Dispatch<SetStateAction<any>>;
  audioDuration?: any;
  singleTrackPage?: boolean;
  stopAll?: () => void;
  isFileAdded?: boolean;
  isTrackConnectedToTutorial: boolean;
  evokeCallBack?: number;
  setEvokeCallBack?: Dispatch<SetStateAction<number>>;
  hasPaymentMethod: boolean;
  allowDownload?: boolean;
  handleCheckedTrackChange?: (track: TrackObj, id: string) => void;
  isBoxChecked?: boolean;
  shareToken?: string | undefined;
  handleOpenPublishModal?: (id: string) => void;
  upsertTrackInState?: (trackToUpsert: TrackObj) => void;
  session?: Session;
  setInbox?: Dispatch<SetStateAction<Inbox | undefined>>;
  shareId: string
}

export interface TrackObj {
  track: Track | undefined;
  trackUrl: string;
  isPlaying: boolean;
  waveSurfer?: WaveSurfer;
  versionCount: number | undefined;
  latestVersion: TrackVersion | undefined;
  notifications: Event[] | undefined
}

export interface TrackVersionsObj {
  track: TrackVersion | undefined;
  isPlaying?: boolean;
  isSelected?: boolean;
}

export interface TrackAddModalProps {
  trackToEdit: Track | undefined;
  trackToEditUrl: string | undefined;
  handleCloseTrackAddModal?: () => void;
  handleRefreshTracks?: () => Promise<void>;
  isModalOpen?: boolean;
}

export interface BatchTrackAddModalProps {
  setIsUploading: Dispatch<SetStateAction<boolean>>;
  setUploadingFilesDetailsList: Dispatch<SetStateAction<UploadedFileInfo[]>>;
  setUploadingCardsStatusList: Dispatch<SetStateAction<UploadCardStatusInfo[]>>;
  handleCloseBatchTrackAddModal: () => void;
  handleAddMusicMenuClose?: () => void;
  isModalOpen: boolean;
  handleOpenMessageModal: () => void;
  setIsUploadProcessing: Dispatch<SetStateAction<boolean>>;
  setFolderUploadInfo: Dispatch<SetStateAction<FolderUploadInfo | undefined>>
}

export interface KeyComponentProps {
  songKey: string;
  scale: string;
  showKeyTooltip: boolean;
  setShowKeyTooltip: React.Dispatch<React.SetStateAction<boolean>>;
  handleshowKeyTooltip: () => void;
  handleScale: (event: React.MouseEvent<HTMLElement>, newScale: string) => void;
  handleKey: (
    event: React.MouseEvent<HTMLElement>,
    newKey: string | null
  ) => void;
}

export interface AddVersionModalProps {
  open: any;
  handleClose: any;
  track?: Track;
  handleFileAdded?: () => void;
  parentFolderId?: string;
}

export type TrackFilterParams = {
  userIds: string[];
  sortBy: string;
  isAscending: boolean;
  genreList: string[];
  artistList: string[];
  collaboratorsList: string[];
  TrackPrivacy: string;
  page: number;
  limit: number;
  bpmStartValue: number;
  bpmEndValue: number;
  status: string;
  isCompletedTracks: boolean
};

export const enum VersionAction {
  VersionAdded = 0,
  TrackEdited = -1,
  TrackAdded = 1,
}
